function snow(props) {

    var speed = props.speed;
    var color = props.color;
    var zIndex = props.zIndex;
    var wind = props.wind;
    var swing = props.swing;

    var canvas = getCanvas(zIndex);
    window.onresize = function () {
        canvas = canvasResize(canvas);
    };
    //let it snow, let it snow, ...
    var itSnow = snowflakes(color, wind, swing);
    setInterval(function () { return itSnow(canvas); }, speed);
}

function getCanvas(zIndex) {
    var canvas = document.getElementById('vue-niege-canvas');
    canvas.style.pointerEvents = "none";
    canvas.style.position = "fixed";
    canvas.style.top = 0;
    canvas.style.left = 0;
    canvas.style.width = "100vw";
    canvas.style.height = "100vh";
    canvas.style.zIndex = zIndex;
    canvas.style.userSelect = "none";
    return canvasResize(canvas);
}

function canvasResize(currentCanvas) {
    currentCanvas.height = currentCanvas.offsetHeight;
    currentCanvas.width = currentCanvas.offsetWidth;
    return currentCanvas;
}

//KUDOS to Pimp Trizkit, https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
function shadeBlend(p, c0, c1) {
    var n = p < 0 ? p * -1 : p,
        u = Math.round,
        w = parseInt;
    var f = w(c0.slice(1), 16),
        t = w((c1 ? c1 : p < 0 ? "#000000" : "#FFFFFF").slice(1), 16),
        R1 = f >> 16,
        G1 = f >> 8 & 0x00FF,
        B1 = f & 0x0000FF;

    if (R1 > 255 || G1 > 255 || B1 > 255)
        { return '#FFFFFF'; }

    return "#" + (0x1000000 + (u(((t >> 16) - R1) * n) + R1) * 0x10000 + (u(((t >> 8 & 0x00FF) - G1) * n) + G1) * 0x100 + (u(((t & 0x0000FF) - B1) * n) + B1)).toString(16).slice(1)
}

function getColorsArray(selectedColor) {
    if (selectedColor === "#FFFFFF") {
        return [selectedColor, '#F2FFFF', '#D8FFFF', '#BEFFFF']
    } else {
        var shadedcolor1 = shadeBlend(.7, selectedColor);
        var shadedcolor2 = shadeBlend(.6, selectedColor);
        var shadedcolor3 = shadeBlend(.5, selectedColor);
        return [selectedColor, shadedcolor1, shadedcolor2, shadedcolor3];
    }
}

function snowflakeColor(snowflakeColors) {
    return snowflakeColors[Math.floor(Math.random() * snowflakeColors.length) - 1]
}


function snowflakes(color, wind, swing) {

    var flakes = [];
    var selectedColors = getColorsArray(color);

    var swingFlake = function (flakeSwing, velX) {
        if (swing === 0)
            { return velX }
        else
            { return (0.4 * Math.cos(flakeSwing += 0.03) * swing) + velX }
    };

    return function (canvas) {
        var ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.beginPath();
        var random = Math.random();
        var distance = .05 + .95 * random;
        var flake = {};
        flake.x = 1.5 * canvas.width * Math.random() - .5 * canvas.width;
        flake.y = -5 + Math.random();
        var flakeFallingSpeed = 2 * distance * (Math.random() / 2);
        flake.velX = Math.abs(flakeFallingSpeed) < Math.abs(wind) ? flakeFallingSpeed + wind / 20 : wind;
        flake.velY = (4 + 2 * Math.random()) * distance;
        flake.radius = Math.pow(3 * random, 2) / 3;
        flake.color = "" + (snowflakeColor(selectedColors));
        flake.swing = Math.random() * 2 * Math.PI;
        flake.update = function () {
            var t = this;
            t.x += swingFlake(t.swing, t.velX);
            t.y += t.velY;
            ctx.beginPath();
            ctx.arc(t.x, t.y, t.radius, 0, 2 * Math.PI, !1);
            ctx.fillStyle = t.color;
            ctx.fill();
        };

        flakes.push(flake);
        flakes.forEach(function (elem, i) {
            elem.y > canvas.height ? flakes.splice(i, 1) : elem.update();
        });
    }

}

//

var script = {
  name: "Snow",
  mounted: function() {
    this.launchSnowing();
  },

  updated: function() {
    this.launchSnowing();
  },

  methods: {
    launchSnowing: function() {
      if (this.active === true) {
        snow({
          speed: this.fallingSpeed(),
          color: this.color,
          zIndex: this.zIndex,
          wind: this.wind,
          swing: this.swing
        });
      }
    },

    fallingSpeed: function() {
      switch(this.speed) {
        case 'l': 
          return 60;
        case 'h':
          return 5;
        default:
          return 20;
      }
    }
  },

  props: {
    color: {
      type: String,
      validator: function(value) {
        return value.length === 7;
      },
      default: "#00FFFF"
    },
    speed: {
      type: String,
      validator: function(value) {
        return value === 'h' || value === 'm' || value === 'l';
      },
      default: 'm'
    },
    zIndex: {
      type: String
    },
    active: {
      type: Boolean,
      default: true
    },
    wind: {
      type: Number,
      default: 1
    },
    swing: {
      type: Number,
      default: 1
    }
  },
  computed: {
    showSnow: function() {
      return this.active === true;
    }
  }
};

/* script */
            var __vue_script__ = script;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.showSnow
    ? _c("canvas", { attrs: { id: "vue-niege-canvas" } })
    : _vm._e()
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = function (inject) {
    if (!inject) { return }
    inject("data-v-f767568c_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"Snow.vue"}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* component normalizer */
  function __vue_normalize__(
    template, style, script$$1,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    var component = (typeof script$$1 === 'function' ? script$$1.options : script$$1) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "C:\\SRC\\React\\vue-niege\\src\\Snow.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) { component.functional = true; }
    }

    component._scopeId = scope;

    {
      var hook;
      if (style) {
        hook = function(context) {
          style.call(this, createInjector(context));
        };
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          var originalRender = component.render;
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context)
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = component.beforeCreate;
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    var head = document.head || document.getElementsByTagName('head')[0];
    var styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {});
    var isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) { return } // SSR styles are present.

      var group = isOldIE ? css.media || 'default' : id;
      var style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined });

      if (!style.ids.includes(id)) {
        var code = css.source;
        var index = style.ids.length;

        style.ids.push(id);

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']');
        }

        if (!style.element) {
          var el = style.element = document.createElement('style');
          el.type = 'text/css';

          if (css.media) { el.setAttribute('media', css.media); }
          if (isOldIE) {
            el.setAttribute('data-group', group);
            el.setAttribute('data-next-index', '0');
          }

          head.appendChild(el);
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'));
          style.element.setAttribute('data-next-index', index + 1);
        }

        if (style.element.styleSheet) {
          style.parts.push(code);
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n');
        } else {
          var textNode = document.createTextNode(code);
          var nodes = style.element.childNodes;
          if (nodes[index]) { style.element.removeChild(nodes[index]); }
          if (nodes.length) { style.element.insertBefore(textNode, nodes[index]); }
          else { style.element.appendChild(textNode); }
        }
      }
    }
  }
  /* style inject SSR */
  

  
  var component = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    __vue_create_injector__,
    undefined
  );

// Import vue component

// install function executed by Vue.use()
function install(Vue) {
  if (install.installed) { return; }
  install.installed = true;
  Vue.component('Snow', component);
}

// Create module definition for Vue.use()
var plugin = {
  install: install,
};

// To auto-install when vue is found
/* global window global */
var GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}

// It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default component;



// WEBPACK FOOTER //
// ./../vue-niege/dist/snow.esm.js